import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    readonly defaultAcceptContentType = "application/pdf,application/vnd.ms-word,image/*"
    private baseUrl: string = window.location.origin + "/";
    
    // making an instance for Get Request
    constructor(
        private httpClient: HttpClient
    )
    { }


    get<T>(apiUrl: string, data?: any): Promise<T> {
        let result = this.httpClient
            .get<T>(this.baseUrl + apiUrl, {
                headers: new HttpHeaders()
                    //.append("Authorization", this.readCookie("X-Auth-Token"))
                    .append("accept", "application/json")
                    .append("Cache-Control", "no-store")
                    .append("Pragma", "no-cache")
                    .append("Expires", "-1")
                    .append("If-Modified-Since", "0")
            }).toPromise()
            .then(data => data as T)
            .catch(this.handleError);
        return result;
    }

    getById<T>(apiUrl: string, id?: number | string): Promise<T> {
        let finalUrl = this.baseUrl + apiUrl + (id ? "/" + id : "");
        let result = this.httpClient
            .get<T>(finalUrl, {
                headers: new HttpHeaders()
                    //.append("Authorization", this.readCookie("X-Auth-Token"))
                    .append("accept", "application/json")
                    .append("Cache-Control", "no-store")
                    .append("Pragma", "no-cache")
                    .append("Expires", "-1")
                    .append("If-Modified-Since", "0")
            }).toPromise()
            .then(data => data as T)
            .catch(this.handleError);
        return result;
    }

    post<T>(apiUrl: string, data: any): Promise<T> {
        let result = this.httpClient
            .post<T>(this.baseUrl + apiUrl, JSON.stringify(data), {
                headers: new HttpHeaders()
                    //.append("Authorization", this.readCookie("X-Auth-Token"))
                    .append("accept", "application/json")
                    .append("content-type", "application/json")
                    .append("Cache-Control", "no-store")
                    .append("Pragma", "no-cache")
                    .append("Expires", "-1")
            }).toPromise()
            .then(data => data as any)
            .catch(this.handleError);
        return result;

    }

    actionsteppost<T>(apiUrl: string, data: any): Promise<T> {
        let result = this.httpClient
            .post<T>( apiUrl, JSON.stringify(data), {
                headers: new HttpHeaders()
                    //.append("Authorization", this.readCookie("X-Auth-Token"))
                    .append("accept", "application/json")
                    .append("content-type", "application/json")
                    .append("Cache-Control", "no-store")
                    .append("Pragma", "no-cache")
                    .append("Expires", "-1")
            }).toPromise()
            .then(data => data as any)
            .catch(this.handleError);
        return result;

    }

    put<T>(apiUrl: string, data: any, id?: number): Promise<T> {
        let finalUrl = this.baseUrl + apiUrl + (id ? "/" + id : "");
        let result = this.httpClient
            .put<T>(finalUrl, JSON.stringify(data), {
                headers: new HttpHeaders()
                    //.append("Authorization", this.readCookie("X-Auth-Token"))
                    .append("accept", "application/json")
                    .append("content-type", "application/json")
                    .append("Cache-Control", "no-store")
                    .append("Pragma", "no-cache")
                    .append("Expires", "-1")
            }).toPromise()
            .then(data => data as any)
            .catch(this.handleError);
        return result;

    }

    //this method used to call WebAPI for patch type. 
    patch<T>(apiUrl: string, data: any): Promise<T> {
        let result = this.httpClient
            .patch<T>(this.baseUrl + apiUrl, data, {
                headers: new HttpHeaders()
                    //.append("Authorization", this.readCookie("X-Auth-Token"))
                    .append("accept", "application/json")
                    .append("content-type", "application/json")
                    .append("Cache-Control", "no-store")
                    .append("Pragma", "no-cache")
                    .append("Expires", "-1")
            }).toPromise()
            .then(data => data as any)
            .catch(this.handleError);

        return result;
    }

    delete<T>(apiUrl: string, id: any): Promise<T> {
        let finalUrl = this.baseUrl + apiUrl + (id ? "/" + id : "");
        let result = this.httpClient
            .delete<T>(finalUrl, {
                headers: new HttpHeaders()
                    //.append("Authorization", this.readCookie("X-Auth-Token"))
                    .append("accept", "application/json")
                    .append("content-type", "application/json")
                    .append("Cache-Control", "no-store")
                    .append("Pragma", "no-cache")
                    .append("Expires", "-1")
            }).toPromise()
            .then(data => data as T)
            .catch(this.handleError);
        return result;
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error);
    }


    getUrlTitle(url: string): Promise<string> {
        let result = fetch(url)
            .then((response) => response.text())
            .then((html) => {
                const doc = new DOMParser().parseFromString(html, "text/html");
                const title = doc.querySelectorAll('title')[0];
                return title.innerText;
            });

        return result;
    }
}
